<template>
  <div id="customer_counter_offer_modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="customerCounterOfferLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 480px;">
      <div class="modal-content text-center position-relative" style="background: #111; border: 1px solid rgba(255,255,255,0.1); border-radius: 24px; box-shadow: 0 20px 40px rgba(0,0,0,0.5);">
        
        <!-- Top-Right Close Button -->
        <button type="button" class="close position-absolute" data-dismiss="modal" aria-label="Close" 
                style="top: 16px; right: 20px; z-index: 10; opacity: 1; text-shadow: none; background: rgba(255,255,255,0.1); width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; border: none; cursor: pointer; transition: all 0.2s;">
          <i class="fa fa-times text-white font-size-14"></i>
        </button>

        <div class="modal-body pt-0 px-4 px-md-5 pb-4">
          <!-- Header Badge & Title -->
          <div class="mb-4 mt-4 text-center">
            <div class="d-inline-flex align-items-center justify-content-center mb-3" style="width: 64px; height: 64px; border-radius: 50%; background: linear-gradient(135deg, rgba(243,218,107,0.2) 0%, rgba(229,59,185,0.2) 100%); border: 1px solid rgba(243,218,107,0.35);">
              <i class="fa fa-handshake-o font-size-28" style="background: linear-gradient(90deg, #F3DA6B, #E53BB9); -webkit-background-clip: text; -webkit-text-fill-color: transparent;"></i>
            </div>
            <h4 class="text-white font-weight-700 mb-2 font-size-20">Review Counter-Offer</h4>
            <p class="text-muted font-size-14 mb-0">
              The creator has proposed an updated price or description for your request.
            </p>
          </div>

          <!-- Counter Offer Note & Price Card -->
          <div class="mb-4 text-left p-3" style="background: rgba(255, 255, 255, 0.03); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 16px;">
            <p class="font-size-14 text-white mb-3" style="line-height: 1.5; opacity: 0.9; font-style: italic;">
              "{{customRequest.counterOfferDescription}}"
            </p>
            <div class="d-flex justify-content-between align-items-center border-top pt-3" style="border-color: rgba(255,255,255,0.08) !important;">
              <span class="text-muted font-size-13">Updated Price</span>
              <span class="font-size-20 font-weight-700" style="color: #F3DA6B;">${{ customRequest.counterOfferPrice }}</span>
            </div>
          </div>

          <!-- Dual Action Buttons (Side by Side) -->
          <div class="mt-2 d-flex align-items-center justify-content-between" style="gap: 12px;">
            <button @click.prevent="declineOffer()"
                    type="button"
                    class="cp-btn-ghost flex-fill py-2">
              Decline
            </button>
            <button @click="acceptOffer()"
                    type="button"
                    class="cp-btn-primary flex-fill py-2">
              Accept Offer
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {customerCustomRequestMixin} from "@/mixin/customer-custom-request-mixin";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import {clone} from "@/common/Utils";

export default {
  name: "ModelCustomerCustomRequestCounterOffer",
  mixins: [customerCustomRequestMixin],
  methods: {
    show(customRequest) {
      this.clearMessages();
      this.customRequest = clone(customRequest);
      $('#customer_counter_offer_modal').modal();
    },
    hide() {
      $('#customer_counter_offer_modal').modal('hide');
    },
    acceptOffer() {

      let customerId = this.customRequest.customer.id;
      let customRequestId = this.customRequest.id;
      ///api/v1/customers/${customerId}/custom-request/${customRequestId}/accept-counter-offer
      let url = `${SERVICE_CONTENT}/api/v1/customers/${customerId}/custom-request/${customRequestId}/accept-counter-offer`;
      this.patchData(url, this.customRequest, (data) => {
        this.hide();
        this.$store.dispatch('setMessage', 'Counter offer accepted!');
        this.$emit('accepted');
      });
    },
    counterOffer() {
      this.hide();
      this.$emit('counterOffer', this.customRequest);
    },
    declineOffer() {

      let customerId = this.customRequest.customer.id;
      let customRequestId = this.customRequest.id;
      //api/v1/customers/${customerId}/custom-request/${customRequestId}/deny-counter-offer
      let url = `${SERVICE_CONTENT}/api/v1/customers/${customerId}/custom-request/${customRequestId}/deny-counter-offer`;
      this.patchData(url, this.customRequest, (data) => {
        this.hide();
        this.$store.dispatch('setMessage', 'Counter offer declined.');
        this.$emit('declined');
      });
    },
    back() {
      this.hide();
      this.$emit('back');
    }
  }
}
</script>


